import React from 'react';

const SvgVerticalRink = props => (
  <svg
    {...props}
    width={props.width}
    height={props.height}
    viewBox={props.viewBox}
  >
    <path
      fill="#FFF"
      stroke="#231F20"
      strokeWidth={1.549}
      strokeMiterlimit={10}
      d="M156.033 23.393c0-11.078-9.074-20.152-20.154-20.152H21.292c-11.079 0-20.153 9.074-20.153 20.152v324.034c.105 11.079 9.074 20.153 20.153 20.153h114.481c11.08 0 20.154-9.074 20.154-20.153l.106-324.034h0z"
    />
    <defs>
      <path
        id="vertical-rink_svg__a"
        d="M-61.009-31.685h322.872V614.06H-61.009z"
      />
    </defs>
    <clipPath id="vertical-rink_svg__b">
      <use xlinkHref="#vertical-rink_svg__a" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#vertical-rink_svg__b)"
      fill="none"
      stroke="#FFF"
      strokeWidth={1.25}
      strokeMiterlimit={10}
      d="M261.863 620.391v15.828m0-674.235v-15.827M-61.009 620.391v15.828m0-674.235v-15.827m329.202 667.904h15.828m-351.361 0h-15.827m351.36-645.746h15.828m-351.361 0h-15.827"
    />
    <defs>
      <path
        id="vertical-rink_svg__c"
        d="M-61.009-31.685h322.872V614.06H-61.009z"
      />
    </defs>
    <clipPath id="vertical-rink_svg__d">
      <use xlinkHref="#vertical-rink_svg__c" overflow="visible" />
    </clipPath>
    <path
      clipPath="url(#vertical-rink_svg__d)"
      fill="none"
      stroke="#010101"
      strokeWidth={0.25}
      strokeMiterlimit={10}
      d="M261.863 620.391v15.828m0-674.235v-15.827M-61.009 620.391v15.828m0-674.235v-15.827m329.202 667.904h15.828m-351.361 0h-15.827m351.36-645.746h15.828m-351.361 0h-15.827"
    />
    <path
      fill="none"
      stroke="#ED2224"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M1.139 185.674H4.41M152.445 185.674h3.272"
    />
    <path
      fill="none"
      stroke="#ED2224"
      strokeWidth={2.065}
      strokeMiterlimit={10}
      d="M1.35 184.196h154.789M1.35 185.41h154.789"
    />
    <path
      fill="none"
      stroke="#3A53A4"
      strokeWidth={4.13}
      strokeMiterlimit={10}
      d="M1.561 138.614h154.578"
    />
    <path
      fill="none"
      stroke="#ED2224"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M1.139 23.499h154.578M156.033 195.17c-5.064 0-9.285-4.115-9.285-9.285s4.115-9.285 9.285-9.285M56.111 23.604L50.414 3.346M100.955 23.604l5.592-20.258"
    />
    <path fill="#231F20" d="M7.258 63.172h63.625H7.258z" />
    <path
      fill="none"
      stroke="#ED2224"
      strokeWidth={1.033}
      strokeMiterlimit={10}
      d="M7.258 63.172h63.625M7.258 68.975h63.625"
    />
    <g>
      <path
        fill="#FFF"
        d="M66.874 66.127c0 15.404-12.556 27.961-27.961 27.961S10.952 81.531 10.952 66.127c0-15.406 12.556-27.962 27.961-27.962s27.961 12.45 27.961 27.962"
      />
      <circle
        fill="#FFF"
        stroke="#ED2224"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        cx={38.913}
        cy={66.127}
        r={27.961}
      />
      <path
        fill="none"
        stroke="#ED2224"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M37.33 56.842v5.697h-5.487M40.812 56.842v5.697h5.803M37.33 75.518v-5.804h-5.487M40.812 75.518v-5.804h5.803"
      />
      <path fill="none" d="M87.238 63.172h63.625" />
      <path
        fill="none"
        stroke="#ED2224"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M87.238 63.172h63.625M87.344 68.975h63.519"
      />
      <path
        fill="#FFF"
        d="M146.959 66.127c0 15.404-12.557 27.961-27.961 27.961-15.406 0-27.961-12.557-27.961-27.961 0-15.406 12.555-27.962 27.961-27.962a27.875 27.875 0 0 1 27.961 27.962"
      />
      <circle
        fill="none"
        stroke="#ED2224"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        cx={118.998}
        cy={66.127}
        r={27.961}
      />
      <path
        fill="none"
        stroke="#ED2224"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M117.309 56.842v5.697h-5.487M120.791 56.842v5.697h5.803M117.309 75.518v-5.804h-5.487M120.791 75.518v-5.804h5.803"
      />
      <circle
        fill="none"
        stroke="#3A53A4"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        cx={78.48}
        cy={185.674}
        r={27.961}
      />
      <circle
        fill="#3A53A4"
        stroke="#3A53A4"
        strokeWidth={0.295}
        strokeMiterlimit={10}
        cx={78.48}
        cy={185.674}
        r={2.005}
      />
      <path
        fill="#FFF"
        stroke="#ED2224"
        strokeMiterlimit={10}
        d="M87.238 18.645c0-2.109-1.688-3.798-3.693-3.798h-9.707c-2.11 0-3.693 1.688-3.693 3.798v4.748s0 .106.105.106h17.198c-.21 0-.21-4.854-.21-4.854z"
      />
      <path
        fill="none"
        stroke="#ED2224"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M87.238 18.645c0-2.109-1.688-3.798-3.693-3.798h-9.707c-2.11 0-3.693 1.688-3.693 3.798v4.748s0 .106.105.106h17.198c-.21 0-.21-4.854-.21-4.854z"
      />
      <path
        fill="#AED8E6"
        stroke="#ED2224"
        strokeMiterlimit={10}
        d="M89.665 34.051V23.499H67.612v10.552c2.744 3.059 6.542 5.064 10.974 5.064 4.537.106 8.336-1.899 11.079-5.064"
      />
      <path
        fill="none"
        stroke="#ED2224"
        strokeWidth={1.033}
        strokeMiterlimit={10}
        d="M89.665 34.051V23.499H67.612v10.552c2.744 3.059 6.542 5.064 10.974 5.064 4.537.106 8.336-1.899 11.079-5.064z"
      />
      <path
        fill="#ED2224"
        d="M40.601 149.482c0 1.055-.844 2.005-2.005 2.005s-2.005-.845-2.005-2.005.844-2.005 2.005-2.005 2.005.951 2.005 2.005M120.686 149.482a2.003 2.003 0 0 1-2.004 2.005c-1.057 0-2.006-.845-2.006-2.005s.844-2.005 2.006-2.005a2.005 2.005 0 0 1 2.004 2.005M40.601 66.127c0 .844-.739 1.582-1.583 1.582s-1.583-.738-1.583-1.582c0-.845.738-1.583 1.583-1.583s1.583.633 1.583 1.583M120.58 66.127c0 .844-.738 1.582-1.582 1.582s-1.584-.738-1.584-1.582c0-.845.74-1.583 1.584-1.583.949 0 1.582.633 1.582 1.583"
      />
    </g>
    {props.data.map((entry, index) => (
      <circle
        //xy - > -y, x
        cx={(entry.xcoord + props.w / 2) * props.xmulti}
        cy={(entry.ycoord + props.h / 2) * props.ymulti}
        r="1"
      />
    ))}
    <circle
      //xy - > -y, x
      cx={90}
      cy={213}
      r="1"
    />
    <circle
      //xy - > -y, x
      cx={1}
      cy={1}
      r="1"
    />
  </svg>
);

export default SvgVerticalRink;



// WEBPACK FOOTER //
// ./src/Components/SvgVerticalRink.js